import Vue, { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { CombinedVueInstance } from 'vue/types/vue';

function numbersOnlyBinding(decimal = false, extraCharsAllowed: string[] = []) {
	return (el: HTMLElement, binding: DirectiveBinding, vNode: VNode) => {
		let oldValue: string;
		const input: HTMLInputElement = el.querySelector('input') as HTMLInputElement;
		let allowedButtons = [
			'Backspace',
			'ArrowLeft',
			'ArrowRight',
			'Right',
			'Left',
			'Del',
			'Delete',
			'Home',
			'End'
		];

		if (decimal)
			allowedButtons = [...allowedButtons, '.', ','];

		allowedButtons = allowedButtons.concat(extraCharsAllowed);

		const regexp = () => {
			const allowedSymbols = extraCharsAllowed;
			if (decimal)
				allowedSymbols.push(',');
			const regexStr = allowedSymbols.map(s => `\\${s}`).join('');
			return new RegExp(`[^0-9${regexStr}]+`, 'g');
		};

		const rememberValue = () => oldValue = input.value as string;
		const isNotNumber = (insert: string) => regexp().test(insert);
		// Transforming dots to commas and disallow add more than 2 digits after it
		const fixDots = () => {
		  if (!decimal)
		    return;

		  let value = input.value
				.replace(/\./, ',')
				.replace(',', 'comma')
				.replace(/,/, '')
				.replace('comma', ',');

		  const arr = value.split(',');

		  if (arr[1])
		    arr[1] = arr[1].slice(0, 2);

		  input.value = arr.join(',');
		};

		// On some android devices prevent default not working for input and keydown events
		const fixValue = () => input.value = input.value.replace(regexp(), '');

		el.addEventListener('keydown', (event) => {
			rememberValue();
			const insert: string | undefined = event.key;

			if (!event.metaKey && !event.ctrlKey && !allowedButtons.includes(insert) && isNotNumber(insert))
				event.preventDefault();
		});

		el.addEventListener('paste', e => {
			rememberValue();
			// @ts-ignore window.clipboardData not ts friendly
			const clipBoardData = (e.clipboardData || window.clipboardData).getData('text') as string;
			if (isNotNumber(clipBoardData))
				e.preventDefault();

			fixDots();
			fixValue();
		});

		el.addEventListener('input', () => {
			fixDots();
			fixValue();
			if (input.value !== oldValue) {
				const context: CombinedVueInstance<Vue, unknown, unknown, unknown, any> = vNode.context;
				if(binding.expression)
					context[binding.expression](input.value);
			}
		});
	};
}

Vue.directive('numbersOnly', {
	bind: numbersOnlyBinding()
});

Vue.directive('numbersOnlyDecimal', {
	bind: numbersOnlyBinding(true)
});

Vue.directive('phoneNumber', {
	bind: numbersOnlyBinding(false, ['/', '-', '.', '+', ' '])
});
